import { render, staticRenderFns } from "./SpotMetricsPanelControl.global.vue?vue&type=template&id=651a95da&lang=pug&"
import script from "./SpotMetricsPanelControl.global.vue?vue&type=script&lang=ts&"
export * from "./SpotMetricsPanelControl.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports